// @flow
import constants from "./CONSTANTS";

const actions = {
  resetAll: () => ({
    type: constants.RESET_ALL
  }),
  loginRequest: (userName, password) => ({
    type: constants.LOGIN_REQ,
    userName,
    password,
  }),
  changeUserPassword: ({ oldPassword, newPassword }) => ({
    type: constants.CHANGE_USER_PASSWORD,
    oldPassword,
    newPassword
  }),
  loginSuccess: (user) => ({
    type: constants.LOGIN_SUCCESS,
    value: user,
  }),
  loginFail: (error) => ({ type: constants.LOGIN_FAIL, error }),
  setUser: (user) => ({ type: constants.SET_USER, user }),
  setSession: (session) => ({
    type: constants.SET_SESSION,
    session,
  }),
  logoutUser: () => ({ type: constants.LOGOUT_USER }),
  loading: (loadingState) => ({
    type: constants.SET_LOADING,
    loadingState,
  }),
  refreshSession: (onSuccess) => ({
    type: constants.REFRESH_SESSION,
    onSuccess,
  }),
  checkSession: () => ({
    type: constants.CHECK_SESSION,
  }),
  userMustChangePassword: (mustChangePassword) => ({
    type: constants.USER_MUST_CHANGE_PASSWORD,
    mustChangePassword,
  }),

  getApprovalsExpirationStatus: () => ({
    type: constants.GET_APPROVAL_EXPIRATION_STATUS,
  }),
  setApprovalsExpirationStatus: (payload) => ({
    type: constants.SET_APPROVAL_EXPIRATION_STATUS,
    payload
  })
};

export default actions;
